import { RootState } from '../../../../store/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_HOST = process.env.REACT_APP_API_HOST;

export interface IConfiguration {
  [key: string]: any;
}

export interface ICompany {
  _id: string;
  userEmail: string;
  domain?: string;
  phone?: string;
  status: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  base_role_super_admin?: boolean;
  image?: string;
  configuration?: any;
}

/**
 * Configuration API (RTK Query)
 */
export const configurationApi = createApi({
  reducerPath: 'configurationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
    credentials: 'include',
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).authorization?.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Configuration', 'Company'],
  endpoints: (build) => ({
    getConfiguration: build.query<IConfiguration, void>({
      query: () => ({
        url: '/configuration',
        method: 'GET',
      }),
      transformResponse: (response: { data: IConfiguration }) => response.data,
      providesTags: ['Configuration'],
    }),

    getCompany: build.query<ICompany, { tenantID: string; token: string }>({
      query: ({ tenantID, token }) => ({
        url: `/tenant/${tenantID}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }),
      transformResponse: (response: { data: ICompany }) => response.data,
      providesTags: ['Company'],
    }),

    fetchConfiguration: build.mutation<IConfiguration, void>({
      query: () => ({
        url: '/configuration',
        method: 'GET',
      }),
      transformResponse: (response: { data: IConfiguration }) => response.data,
      invalidatesTags: ['Configuration'],
    }),

    fetchCompany: build.mutation<ICompany, { tenantID: string; token: string }>({
      query: ({ tenantID, token }) => ({
        url: `/tenant/${tenantID}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }),
      transformResponse: (response: { data: ICompany }) => response.data,
      invalidatesTags: ['Company'],
    }),
  }),
});

export const {
  useGetConfigurationQuery,
  useGetCompanyQuery,
  useFetchConfigurationMutation,
  useFetchCompanyMutation,
} = configurationApi;

